import { makeObservable, override } from 'mobx';

import { AbstractField } from './AbstractField';

export enum PlanRequestStatus {
    Empty = '',
    Updated = 'updated',
    Sended = 'sended',
}

export interface PlanDescriptionFieldValue {
    text: string;
    status: PlanRequestStatus;
}

export class PlanDescriptionField extends AbstractField<PlanDescriptionFieldValue, PlanDescriptionFieldValue> {
    constructor(value: PlanDescriptionFieldValue, name: string) {
        super(value, name);
        makeObservable(this);
    }

    @override
    public get hasData(): boolean {
        return !!this.fieldValue.text?.trim();
    }

    public getPreview(): string {
        return this.fieldValue.text ?? '';
    }

    public makeUpdateParams(): PlanDescriptionFieldValue {
        return this.fieldValue;
    }

    public isEqual(value: PlanDescriptionFieldValue): boolean {
        return this.fieldValue.text === value.text && this.fieldValue.status === value.status;
    }

    protected setDefaultValueValue(): void {
        this.defaultNullValue = { text: '', status: PlanRequestStatus.Empty };
    }

    protected setFieldValue(value: PlanDescriptionFieldValue): void {
        this.fieldValue = value;
    }
}
